module.exports = __webpack_public_path__ + "images/33a50351fb18de2d088a96ef1fdf06f6sound.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sound.png
// module id = +lwL
// module chunks = 0